import { EventEmitter } from '@angular/core';
import { ProtocolDistributor } from '@core/shared/protocol';
import { NG_HTTP_CACHING_CONFIG, NgHttpCachingService } from 'ng-http-caching';
import { CLIENT_CACHE_PROTOCOL, getClientCacheModelId } from './client-cache';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/protocol";
class ClientCacheEvent {}
export class ClientCacheUpdatedEvent extends ClientCacheEvent {}
export let ClientCacheService = /*#__PURE__*/(() => {
  class ClientCacheService extends NgHttpCachingService {
    // // hacked-in access to private parent methods
    // protected readonly _queue = new Map<string, Observable<HttpEvent<any>>>();
    // protected readonly _config: NgHttpCachingDefaultConfig;
    constructor(config, protocol) {
      super();
      this.protocol = protocol;
      this.events$ = new EventEmitter();
    }
    clearCacheForModel(Model) {
      const count = this.clearCacheByTag(getClientCacheModelId(Model));
      this.protocol.write("Cleared cache for Model " + Model.name + ". Wiped cache entries: " + count);
      return count;
    }
    addToCache(req, res) {
      const result = super.addToCache(req, res);
      this.events$.emit(new ClientCacheUpdatedEvent());
      return result;
    }
    deleteFromCache(req) {
      const result = super.deleteFromCache(req);
      this.events$.emit(new ClientCacheUpdatedEvent());
      return result;
    }
    clearCache() {
      super.clearCache();
      this.events$.emit(new ClientCacheUpdatedEvent());
    }
    clearCacheByKey(key) {
      const result = super.clearCacheByKey(key);
      // check is necessary because parent constructor already calls this method via this.runGC()
      if (this.events$) {
        this.events$.emit(new ClientCacheUpdatedEvent());
      }
      return result;
    }
    clearCacheByKeys(keys) {
      let counter = 0;
      if (keys) {
        for (const key of keys) {
          if (this.clearCacheByKey(key)) {
            counter++;
          }
        }
      }
      return counter;
    }
    clearCacheByRegex(regex) {
      const result = super.clearCacheByRegex(regex);
      this.events$.emit(new ClientCacheUpdatedEvent());
      return result;
    }
    static {
      this.ɵfac = function ClientCacheService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClientCacheService)(i0.ɵɵinject(NG_HTTP_CACHING_CONFIG), i0.ɵɵinject(CLIENT_CACHE_PROTOCOL));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ClientCacheService,
        factory: ClientCacheService.ɵfac
      });
    }
  }
  return ClientCacheService;
})();